import { useEffect } from 'react'
import { Icon } from '@mdi/react'
import { mdiCodeTags } from '@mdi/js'

import theme from 'theme_'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { H1 } from 'components/Typography'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import HomeSoftwareUpdates from './HomeSoftwareUpdates'
import HomeSoftwareUpdateProgress from './HomeSoftwareUpdateProgress'
import { homeCloudSoftwareHistoryActions } from './HomeCloudSoftwareHistory/slice'
import {
  HomeSoftwareVersionContainer,
  HomeSoftwareVersionLabel,
  HomeSoftwareVersionValue,
} from './styles'
import { homeSoftwareVersionSelector } from 'features/home/selectors'

// TODO: localization
function HomeSoftware() {
  const dispatch = useAppDispatch()
  const homeSoftwareVersion = useAppSelector(homeSoftwareVersionSelector)

  useEffect(() => {
    return () => {
      dispatch(homeCloudSoftwareHistoryActions.clear())
    }
  }, [dispatch])

  return (
    <StyledFadeInWrapper>
      <H1>Software Update</H1>
      <HomeSoftwareVersionContainer>
        <HomeSoftwareVersionLabel>Current Version</HomeSoftwareVersionLabel>
        <HomeSoftwareVersionValue>
          <Icon path={mdiCodeTags} size={1} color={theme.colors.beachGrey} />
          <span>SavantOS {homeSoftwareVersion.softwareVersionLabel}</span>
        </HomeSoftwareVersionValue>
      </HomeSoftwareVersionContainer>

      <HomeSoftwareUpdates />
      <HomeSoftwareUpdateProgress />
    </StyledFadeInWrapper>
  )
}

export default HomeSoftware
